document.addEventListener('DOMContentLoaded', () => {
  const sectionEl = document.querySelector('[data-section="collapsable-hero-ingr"]');
  if (!sectionEl) return;

  const slider = sectionEl.querySelector('[data-hero-slider]');

  if (slider) {
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;

    slider.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX;
      scrollStart = slider.scrollLeft;
      slider.classList.add('is-dragging');
    });

    // mouseup must be on document to catch drag-release outside the slider bounds.
    // The isDragging guard makes this a no-op in the common (non-dragging) case.
    document.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      slider.classList.remove('is-dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      slider.scrollLeft = scrollStart - (e.pageX - startX);
    });
  }

  const outerAccordion = sectionEl.querySelector(':scope > [data-accordion]');
  const outerContent = outerAccordion?.querySelector(':scope > [data-accordion-content]');
  const nestedContent = sectionEl.querySelector(
    '.collapsable-hero-ingr__nested-accordion [data-accordion-content]'
  );

  if (nestedContent && outerContent) {
    // accordion.js drives height via style.maxHeight (not a CSS class).
    // When the nested accordion opens or closes, the outer accordion's maxHeight
    // was calculated before the nested content changed size — it must be recalculated
    // here after the nested transition ends so the outer content is not clipped.
    nestedContent.addEventListener('transitionend', () => {
      if (outerContent.style.maxHeight && outerContent.style.maxHeight !== '0px') {
        outerContent.style.maxHeight = `${outerContent.scrollHeight}px`;
      }
    });
  }
});
